import { render, staticRenderFns } from "./TicoursesDashboard.vue?vue&type=template&id=3f4981c6"
import script from "./TicoursesDashboard.vue?vue&type=script&lang=js"
export * from "./TicoursesDashboard.vue?vue&type=script&lang=js"
import style0 from "./TicoursesDashboard.vue?vue&type=style&index=0&id=3f4981c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports